import React from "react";
import { Alert, Col } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

const Message = ({ variant, children, setMessage }) => {
  return (
    <>
      {children && (
        <Alert className="m-4 row" variant={variant}>
          <Col className="col-sm-10">{children}</Col>
          {setMessage && (
            <Col className="col-sm-2">
              <div className="row justify-content-end">
                <FaTimes
                  onClick={() => setMessage("")}
                  className="cursor-pointer text-red-600"
                />
              </div>
            </Col>
          )}
        </Alert>
      )}
    </>
  );
};

Message.defaultProps = {
  variant: "info",
};

export default Message;
